;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities.discussion')
    .controller('VulnDiscussionNoteCtrl', VulnDiscussionNoteCtrl)

  function VulnDiscussionNoteCtrl($scope, permissions) {
    'ngInject'

    angular.extend($scope, {
      isReadOnly: isReadOnly,
      isRuleAdminPlus: isRuleAdminPlus
    })

    function isRuleAdminPlus() {
      return permissions.hasAnyPermission('RULE_ADMIN,ADMIN')
    }

    function isReadOnly(note) {
      return angular.isString(note.read_only_property_type)
    }
  }
})()
